// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-8-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11ZM12 11C13.7949 11 15.25 9.54493 15.25 7.75C15.25 5.95507 13.7949 4.5 12 4.5C10.2051 4.5 8.75 5.95507 8.75 7.75C8.75 9.54493 10.2051 11 12 11Z","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers81Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-8-1',
    ref,
    icon: element,
  },
));

Numbers81Icon.displayName = 'Numbers81Icon';

export default Numbers81Icon;
